import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize } from '@fortawesome/pro-regular-svg-icons';
import _ from 'lodash';
import {
    Button,
    ClickAwayListener,
    Grow,
    Paper,
    Popper,
    FormControlLabel,
    Checkbox,
} from '@material-ui/core';
import './TotalHoursDisplay.scss';

/**
 * @param {{ defaultValue: boolean, onChange: (bool) => void }} TotalHoursDisplayProps
 */
const TotalHoursDisplay = ({ defaultValue, onChange }) => {
    /**
     * @type {[HTMLButtonElement | null | undefined, import('react').Dispatch<SetStateAction<HTMLButtonElement | null | undefined>>]}
     */
    const [totalHoursAnchor, setTotalHoursAnchor] = useState();
    const [showTotalHours, setShowTotalHours] = useState(defaultValue);

    const handleCheckboxChange = (checked) => {
        onChange(checked);
        setShowTotalHours(checked);
    };

    return (
        <>
            <Button
                className="total-hours-column-iconButton"
                variant="outlined"
                onClick={(event) => setTotalHoursAnchor(totalHoursAnchor ? null : event.currentTarget)}
            >
                <FontAwesomeIcon
                    transform={{ rotate: -90 }}
                    icon={faWindowMaximize}
                />
            </Button>
            <Popper
                open={!!totalHoursAnchor}
                anchorEl={totalHoursAnchor}
                placement="bottom-start"
                transition
                className="total-hours-popper"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'left bottom' }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={() => setTotalHoursAnchor(null)}>
                                <div className="content">
                                    <FormControlLabel
                                        control={(
                                            <Checkbox
                                                color="primary"
                                                checked={showTotalHours}
                                                onChange={(event) => handleCheckboxChange(event.target.checked)}
                                            />
                                        )}
                                        label="Scheduled weekly hours"
                                    />
                                </div>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default TotalHoursDisplay;
